import React from 'react';
import {
  useLocation,
  withRouter,
} from 'react-router-dom';

import SplitBackgroundImage from './templates/SplitBackgroundImage';
import Fullscreen from './templates/Fullscreen';
import SplitIllustration from './templates/SplitIllustration';
import SplitSolidColorBackground from './templates/SplitSolidColorBackground';
import SplitSolidColorLoginForm from './templates/SplitSolidColorLoginForm';
import DarkmodeLogin from './templates/DarkmodeLogin';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const App = ({ history }) => {
  const query = useQuery();
  const template = query.get('template');
  return (
    <>
      <div className="template-picker">
        <select id="lang" onChange={(e) => history.push(`/?template=${e.target.value}`)}>
          <option value="splitIllustration">Split Illustration</option>
          <option value="fullscreen">Fullscreen</option>
          <option value="splitBackgroundImage">Split Background Image</option>
          <option value="splitSolidColorBackground">Split Solid Color Background</option>
          <option value="splitSolidColorLoginForm">Split Solid Color Login Form</option>
          <option value="darkmodeLogin">Dark Mode Login</option>
        </select>
      </div>
      {template === 'splitIllustration' && <SplitIllustration />}
      {template === 'fullscreen' && <Fullscreen />}
      {template === 'splitBackgroundImage' && <SplitBackgroundImage />}
      {template === 'splitSolidColorBackground' && <SplitSolidColorBackground />}
      {template === 'splitSolidColorLoginForm' && <SplitSolidColorLoginForm />}
      {template === 'darkmodeLogin' && <DarkmodeLogin />}
    </>
  );
};

export default withRouter(App);
